export default "__VITE_ASSET__BlR2ku_4__"